export default __webpack_public_path__ + "static/media/index.c99fc615.png";